/**
 * "This page is out of date" — shown when the server has a newer build than the tab is running.
 *
 * Deliberately a banner and not an automatic reload: a reload would discard whatever is typed in
 * the paste box, which can be twenty thousand rows.
 */
import { useEffect, useState } from 'react';

import { isStale } from '../lib/version';

/** Often enough to catch a deploy during a working session, rarely enough to be invisible. */
const EVERY_MS = 60_000;

export function StaleBuild() {
  const [stale, setStale] = useState(false);

  useEffect(() => {
    const ac = new AbortController();
    const check = () => {
      void isStale(ac.signal).then((v) => {
        if (v) setStale(true);
      });
    };
    check();
    const timer = window.setInterval(check, EVERY_MS);
    // Coming back to the tab is exactly when a deploy is most likely to have happened meanwhile.
    window.addEventListener('focus', check);
    return () => {
      ac.abort();
      window.clearInterval(timer);
      window.removeEventListener('focus', check);
    };
  }, []);

  if (!stale) return null;

  return (
    <div className="sticky top-0 z-50 flex flex-wrap items-center gap-3 bg-amber-500 px-4 py-2 text-sm font-medium text-white shadow">
      <span>
        This page is running an older version. Reload to pick up the latest — anything typed below
        will be lost.
      </span>
      <button
        type="button"
        onClick={() => window.location.reload()}
        className="rounded bg-white px-3 py-1 text-xs font-semibold text-amber-700 hover:bg-amber-50"
      >
        Reload now
      </button>
    </div>
  );
}
